/**
 * Takes a list of fragments (number, number tuples representing the start and end of a fragment)
 * and expands them into a list of each individual fragment.
 * @example splitFragments([[0,1], [3,5]]) => [0, 1, 3, 4, 5]
 * @param fragmentList
 */
export const splitFragments = (fragmentList: [number, number][]): number[] => {
  const fragmentListLength = fragmentList.length
  if (fragmentListLength === 0) return []
  const result: number[] = []
  fragmentList.forEach(([start, end]) => {
    for (let i = start; i <= end; i++) {
      result.push(i)
    }
  })
  return result
}
